export const SETTINGS_KEY = 'digidex.settings';

export const DEFAULT_SETTINGS = {
  libraryTileSize: 160,
  showItemNames: true,
  reduceAnimations: false
};

export function getSettings() {
  try {
    const stored = JSON.parse(localStorage.getItem(SETTINGS_KEY) || '{}');
    const legacyTileSizes = { small: 104, medium: 160, large: 240 };
    const libraryTileSize = Number.isFinite(stored.libraryTileSize)
      ? stored.libraryTileSize
      : legacyTileSizes[stored.imageSize] || DEFAULT_SETTINGS.libraryTileSize;
    return { ...DEFAULT_SETTINGS, ...stored, libraryTileSize };
  } catch {
    return DEFAULT_SETTINGS;
  }
}

export function saveSettings(changes) {
  const next = { ...getSettings(), ...changes };
  localStorage.setItem(SETTINGS_KEY, JSON.stringify(next));
  window.dispatchEvent(new CustomEvent('settings:changed', { detail: next }));
  return next;
}
